"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * iq.ts - Image Quantization Library
 */
var arithmetic = require("./arithmetic");
exports.arithmetic = arithmetic;
var hueStatistics_1 = require("./hueStatistics");
exports.HueStatistics = hueStatistics_1.HueStatistics;
var palette_1 = require("./palette");
exports.Palette = palette_1.Palette;
var point_1 = require("./point");
exports.Point = point_1.Point;
var pointContainer_1 = require("./pointContainer");
exports.PointContainer = pointContainer_1.PointContainer;
var progressTracker_1 = require("./progressTracker");
exports.ProgressTracker = progressTracker_1.ProgressTracker;
//# sourceMappingURL=index.js.map